import { z } from 'zod';

export type CheckoutRequest = z.infer<typeof CheckoutRequestScheme>;
export const CheckoutRequestScheme = z.object({

});

export type CheckoutResponse = z.infer<typeof CheckoutResponseScheme>;
export const CheckoutResponseScheme = z.object({
  oid: z.string(),
});